import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { CallState } from '@lcs/shared/api';
import { UserPasswordResetRequestForm } from '../models/user-password-reset-request.form';
import { UserPasswordResetRequestModel } from '../models/user-password-reset-request.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-user-password-reset-request-view',
    templateUrl: './user-password-reset-request-view.component.html',
    standalone: false
})
export class UserPasswordResetRequestViewComponent implements OnInit {
   @Input() loading: CallState;

   @Output() passwordResetRequest = new EventEmitter<UserPasswordResetRequestModel>();

   @Output() formCanceled = new EventEmitter<void>();

   form: UntypedFormGroup;

   get formControls() {
      return this.form.controls;
   }

   constructor(private fb: UntypedFormBuilder) {}

   ngOnInit(): void {
      const form: UserPasswordResetRequestForm = {
         emailAddress: this.fb.control(null),
         username: this.fb.control(null),
      };
      this.form = this.fb.group(form);
   }

   onSave(): void {
      if (this.form.valid) {
         this.passwordResetRequest.emit(this.getPasswordResetRequest());
         this.form.markAsPristine();
         this.form.markAsUntouched();
      }
   }

   onClose() {
      this.formCanceled.emit();
   }

   private getPasswordResetRequest(): UserPasswordResetRequestModel {
      const formValue: UserPasswordResetRequestModel = this.form.value;
      const passwordResetRequest: UserPasswordResetRequestModel = {
         ...formValue,
      };
      return passwordResetRequest;
   }
}
